import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "react-feather";
import styles from "./footer.module.css";

const LINKS = [
  { to: "/customer/my-bookings", label: "My bookings" },
  { to: "/customer/add-booking", label: "Add a booking" },
  { to: "/customer/track-booking", label: "Track a booking" },
  { to: "/customer/referral-histories", label: "Referral history" },
  { to: "/customer/profile", label: "My profile" },
];

// Customer panel footer in the company's theme colours, with its contact details
const Footer = ({ companyName = "Company", logo, phone, email, address }) => {
  const year = new Date().getFullYear();
  const hasContact = phone || email || address;

  return (<footer className={styles.Footer}>
    <div className={styles.Container}>
      <div className={styles.FooterTop}>
        <div className={styles.BrandCol}>
          {logo && (
            <span className={styles.LogoWrap}>
              <img src={logo} alt={companyName} className={styles.Logo} />
            </span>
          )}
          <p className={styles.BrandName}>{companyName}</p>
          <p className={styles.BrandText}>Book, track and manage your shipments in one place.</p>
        </div>

        <nav className={styles.LinksCol} aria-label="Footer">
          <p className={styles.ColTitle}>Your account</p>
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to}>{l.label}</Link>
          ))}
        </nav>

        {hasContact && (
          <div className={styles.ContactCol}>
            <p className={styles.ColTitle}>Contact us</p>
            {phone && (
              <a href={"tel:" + phone.replace(/\s+/g, "")}><Phone size={15} /><span>{phone}</span></a>
            )}
            {email && (
              <a href={"mailto:" + email}><Mail size={15} /><span>{email}</span></a>
            )}
            {address && (
              <p className={styles.Address}><MapPin size={15} /><span>{address}</span></p>
            )}
          </div>
        )}
      </div>
    </div>

    <div className={styles.FooterBottom}>
      <div className={styles.Container}>
        <p className={styles.CopyText}>© {year} {companyName}. All rights reserved.</p>
      </div>
    </div>
  </footer>);
}

export default Footer;
